import { CommandBarButton, IButtonProps, IconButton } from "@fluentui/react";
import * as React from "react";

import { TooltipHost } from "../../surfaces/tooltip/TooltipHost";

export type EditButtonProps = Pick<IButtonProps, "id" | "disabled" | "onClick" | "styles"> & {
    isLabeled?: boolean;
    label?: string;
    testId: string;
    iconName?: string;
};

export const EditButton: React.FunctionComponent<EditButtonProps> = (props: EditButtonProps) => {
    const label = props.label || "Edit";

    return (
        <>
            {props.isLabeled ? (
                <CommandBarButton
                    key={props.id}
                    iconProps={{ iconName: "Edit" }}
                    disabled={props.disabled}
                    onClick={props.onClick}
                    allowDisabledFocus={false}
                    checked={false}
                    ariaLabel={label}
                    text={label}
                    styles={props.styles}
                    data-testid={`${props.testId}-button`}
                />
            ) : (
                <TooltipHost content={label} styles={{ root: { display: "inline-block" } }}>
                    <IconButton
                        key={props.id}
                        iconProps={{ iconName: props.iconName ?? "Edit" }} // or EditSolid12
                        disabled={props.disabled}
                        onClick={props.onClick}
                        allowDisabledFocus={false}
                        checked={false}
                        ariaLabel={label}
                        styles={props.styles}
                        data-testid={`${props.testId}-button`}
                    />
                </TooltipHost>
            )}
        </>
    );
};
